import React from "react";
import { Link } from "react-router-dom";


export default function Credits() {
  return (
    <div className="relative min-h-screen w-full flex flex-col justify-start items-center px-6 py-10 bg-gradient-to-b from-indigo-900 via-purple-800 to-pink-600 text-white">
      
     {/* 🔝 Logo Top-Left */}
<div className="absolute top-6 left-6 z-30">
  <Link to="/">
    <img
      src="/M-logo.png"
      alt="MazeMoh Logo"
      className="w-12 h-12 object-contain"
    />
  </Link>
</div>


      {/* ✨ Main Title */}
      <h1 className="mt-24 text-4xl sm:text-5xl font-bold mb-6 text-yellow-200 flex items-center gap-2">
        ✨ Credits
      </h1>

      {/* 🎧 Music Credit */}
      <p className="mb-2 text-center text-white max-w-xl">
        Background music provided by great artists of{" "}
        <a
          href="https://pixabay.com/music/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-blue-300 hover:text-white"
        >
          pixabay
        </a>
      </p>

      {/* 🌀 Motion Credit */}
      <p className="mb-2 text-center text-white max-w-xl">
        Motion components inspired from{" "}
        <a
          href="https://github.com/motiondivision/motion"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-blue-300 hover:text-white"
        >
          Motion One
        </a>{" "}
        
        
      </p>
      <p className="mb-2 text-center text-white max-w-xl">
  Coding guidance and Conceptual discussion  and inspiration from{" "}
  <a
    href="https://openai.com/chatgpt"
    target="_blank"
    rel="noopener noreferrer"
    className="underline text-blue-300 hover:text-white"
  >
    ChatGPT by OpenAI
  </a>{" "}
  and{" "}
  <a
    href="https://www.anthropic.com/claude"
    target="_blank"
    rel="noopener noreferrer"
    className="underline text-blue-300 hover:text-white"
  >
    Claude by Anthropic
  </a>
</p>

      {/* 🌐 Community */}
      <p className="mb-2 text-center text-white max-w-xl">
        Thanks to the open source community ✨
      </p>
{/* 🔒 Privacy Statement */}

 
    <h1 className="mt-24 text-4xl sm:text-5xl font-bold mb-6 text-yellow-200 flex items-center gap-2">
        ✨ Privacy
      </h1>
       <p className="mb-2 text-center text-white max-w-xl">
    MazeMoh does not collect, store, or share any personal data.<br />
    We do not require login, and no cookies or tracking tools are used. <br />
    All gameplay happens locally in your browser and is not transmitted to any server.
    Any changes to privacy in future will be promtly communicated.
  </p>


      {/* 🔙 Return Button */}
      <div className="mt-10">
        <Link
          to="/"
          className="bg-gradient-to-r from-orange-400 to-red-500 text-white font-semibold py-2 px-6 rounded-full shadow-xl hover:scale-105 transition-transform duration-300"
        >
          🏠 Return to Home
        </Link>
      </div>
    </div>
  );
}
